import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import {
  formatBytes,
  getFileExtension,
  getImageResolution,
} from '../../../helpers/Files';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicateListItem = ({
  duplicate,
  mode,
  selected,
  handleSetDuplicate,
}) => {
  const file = duplicate.files[0];
  const extension = getFileExtension(file);
  const resolution = getImageResolution(file);

  const intl = useIntl();

  return (
    <ErrorBoundary>
      <li
        id={`duplicated-file-${duplicate.uuid}`}
        className={classnames('duplicated-file', { selected })}
        role="menuitem"
        onClick={handleSetDuplicate}
        onKeyPress={handleSetDuplicate}
      >
        <div className="duplicated-file-wrapper">
          <img className="duplicated-file-img grid-item-img" src={file.urls.thumbnailsq} alt="" />
          <div className="duplicated-file-body">
            <h6 className="duplicated-file-title" title={file.display_name}>
              {file.display_name}
            </h6>
            <div className="duplicated-file-details file-details">
              <div>
                {(extension && mode !== 'similar_images') && (
                  <span className="file-extension">
                    {extension}
                  </span>
                )}
                {(resolution && mode !== 'similar_images') && (
                  <span className="file-resolution">
                    {resolution}
                  </span>
                )}
                {(mode !== 'similar_images') && (
                  <span className="file-size">
                    {formatBytes(file.size)}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </li>
      {duplicate.duplicates_size > 0 && (
        <UncontrolledTooltip fade={false} placement="right" target={`duplicated-file-${duplicate.uuid}`}>
          {intl.formatMessage({ defaultMessage: 'save up to {size}' }, { size: formatBytes(duplicate.duplicates_size) })}
        </UncontrolledTooltip>
      )}
    </ErrorBoundary>
  );
};

DuplicateListItem.propTypes = {
  duplicate: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  handleSetDuplicate: PropTypes.func.isRequired,
};

export default DuplicateListItem;
